import { render, staticRenderFns } from "./ActiveFacebookPage.vue?vue&type=template&id=c5b5abe6&"
import script from "./ActiveFacebookPage.vue?vue&type=script&lang=js&"
export * from "./ActiveFacebookPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports